import React from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useContentSlots} from '../../hooks/use-content-slot'

const GlobalContentSlotHtml = (props) => {
    const {slotId, context, type} = props
    const {data: slotData, isSuccess} = useContentSlots(slotId, context, type)
    const parsedHtml = slotData ? parse(slotData) : null

    return <>{isSuccess ? <Box>{parsedHtml}</Box> : null}</>
}

GlobalContentSlotHtml.propTypes = {
    slotId: PropTypes.string.isRequired,
    context: PropTypes.string,
    type: PropTypes.string
}

export default GlobalContentSlotHtml
